import type {
  AntdTreeType,
  CategoryInterface,
  NomenclatureGroupInterface,
} from '@/types'

import HierarchyTreeColumn from './HierarchyTreeColumn/HierarchyTreeColumn'
import cn from './NomenclatureHierarchyPanel.module.scss'

type NomenclatureHierarchyPanelPropsType = {
  maxHeight?: number | null
  nomenclatureGroupsTree: NomenclatureGroupInterface[]
  antdNomenclatureGroupsTree: AntdTreeType[]
  categoriesTree: CategoryInterface[]
  antdCategoriesTree: AntdTreeType[]
  selectedGroupId?: string
  selectedCategoryId?: string
  groupErrorMessage?: string
  categoryErrorMessage?: string
  onGroupSelect: (id: string) => void
  onCategorySelect: (id: string) => void
  setNomenclatureGroupsTree: (tree: NomenclatureGroupInterface[]) => void
  setCategoriesTree: (tree: CategoryInterface[]) => void
  onGroupCreated: () => void
  onCategoryCreated: () => void
  isOrganisationSelected?: boolean
}

function NomenclatureHierarchyPanel(
  props: NomenclatureHierarchyPanelPropsType
) {
  const {
    maxHeight,
    nomenclatureGroupsTree,
    antdNomenclatureGroupsTree,
    categoriesTree,
    antdCategoriesTree,
    selectedGroupId,
    selectedCategoryId,
    groupErrorMessage,
    categoryErrorMessage,
    onGroupSelect,
    onCategorySelect,
    setNomenclatureGroupsTree,
    setCategoriesTree,
    onGroupCreated,
    onCategoryCreated,
    isOrganisationSelected = false,
  } = props

  return (
    <div
      className={cn.panel}
      style={maxHeight ? { '--panel-height': `${maxHeight}px` } : undefined}
    >
      <HierarchyTreeColumn
        treeType="nomenclature-groups"
        title="Группа номенклатуры"
        tree={nomenclatureGroupsTree}
        antdTree={antdNomenclatureGroupsTree}
        selectedId={selectedGroupId}
        required
        errorMessage={groupErrorMessage}
        onSelect={(id) => onGroupSelect(id)}
        onEntityCreated={onGroupCreated}
        setExternalTree={setNomenclatureGroupsTree}
        isOrganisationSelected={isOrganisationSelected}
      />
      <HierarchyTreeColumn
        treeType="categories"
        title="Категория"
        tree={categoriesTree}
        antdTree={antdCategoriesTree}
        selectedId={selectedCategoryId}
        required
        errorMessage={categoryErrorMessage}
        onSelect={(id) => onCategorySelect(id)}
        onEntityCreated={onCategoryCreated}
        setExternalTree={setCategoriesTree}
        isOrganisationSelected={isOrganisationSelected}
      />
    </div>
  )
}

export default NomenclatureHierarchyPanel
